const SET_IS_MOUNTED = (state, toggle) => {
  state.isMounted = toggle;
};

export default SET_IS_MOUNTED;
